import { useMemo } from "react";
import ChipStatus from "../ChipStatus";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const useExcuteStatusOptions = () => {
  const { t } = useTranslation();

  return [
    { id: "success", name: t({ defaultMessage: "已完成" }) },
    { id: "failed", name: t({ defaultMessage: "失败" }) },
    { id: "ignored", name: t({ defaultMessage: "已忽略" }) }
  ];
};

const ExcuteStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const options = useExcuteStatusOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={options}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const ExcuteChipStatus = ({ status }) => {
  const { t } = useTranslation();
  const options = useExcuteStatusOptions();
  let option = useMemo(() => {
    return options
      .concat([{ id: "completed", name: t({ defaultMessage: "已完成" }) }])
      .find(option => option.id === status);
  }, [status]);

  const type = {
    success: "success",
    completed: "success",
    failed: "secondary",
    ignored: "default"
  };

  if (!status) return "";

  if (!option) option = options[1];

  return <ChipStatus type={type[option.id]} label={option.name} />;
};

export default ExcuteStatus;
